import React from 'react'
import {  NavLink } from 'react-router-dom'
import { carbonreductionplan, esgpolicy, gdprpolicy, genderpaygap, modernslaveryact, privacypolicy,Termsandcondition } from '../../Routes/routingConsts'
const CMSEditor = ({children}) => {
    return (
        <>
               <div className="sidebar-content employee-myaccount-page common-page">
                <div className="myaccount edit-profile">
                    <div className="custom-row">
                        <div className="myaccount-sidebar">
                            <ul>
                                <li>
                                    <NavLink
                                        to={privacypolicy}
                                        className="nav-link"
                                        state="Privacy Policy"
                                    >
                                        Privacy Policy
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                    to={Termsandcondition}
                                        className="nav-link"
                                        state="Terms and Conditions"
                                    >
                                        Terms And Conditions
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                    to={gdprpolicy}
                                        className="nav-link"
                                        state="GDPR Policy"
                                    >
                                       GDPR Policy
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                    to={esgpolicy}
                                        className="nav-link"
                                        state="ESG Policy"
                                    >
                                       ESG Policy
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                    to={genderpaygap}
                                        className="nav-link"
                                        state="Gender Pay gap"
                                    >
                                       Gender Pay Gap 
                                    </NavLink>
                                </li>

                                <li>
                                    <NavLink
                                    to={carbonreductionplan}
                                        className="nav-link"
                                        state="Carbon Reduction Plan"
                                    >
                                      Carbon Reduction Plan
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                    to={modernslaveryact}
                                        className="nav-link"
                                        state="Modern Slavery Act"
                                    >
                                     Modern Slavery Act
                                    </NavLink>
                                </li>
                                
                            </ul>
                        </div>
                        {children}
                    </div>
                </div>
            </div>
        </>
    )
}

export default CMSEditor
